import { SET_CUR_PATH } from "../types";

export const set_cur_path = (path) => ({
    type : SET_CUR_PATH,
    path
})